import { Link, LinkProps } from '@chakra-ui/react';

export const INDIGO_HELP_EMAIL = 'help@useindigo.com';

export const ContactUsLink = ({
  children = 'Contact us',
  ...props
}: { children?: React.ReactNode } & LinkProps) => {
  return (
    <Link
      color="link.skyBlue"
      href={`mailto:${INDIGO_HELP_EMAIL}`}
      textTransform="none"
      {...props}
    >
      {children}
    </Link>
  );
};
